import { render, staticRenderFns } from "./PricelistsTopSlot.vue?vue&type=template&id=759ef26c"
import script from "./PricelistsTopSlot.vue?vue&type=script&lang=js"
export * from "./PricelistsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports